<!-- ============================ SINGLE MODE ============================ -->
<ng-container *ngIf="!multiple">

	<!-- "Filter" button w/ drop down options -->
	<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
		<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
			<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
		</button>
		<ul class="dropdown-menu">
			<li *ngFor="let option of options" (click)="onOptionClicked(option)">
				<a>{{ option.label }}</a>
			</li>
		</ul>
	</div>

	<!-- Filter label + value input (only when a real filter is selected) -->
	<ng-container *ngIf="selected?.column != null">

		<!-- Filter Label -->
		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			{{ selected.label }}
		</div>

		<!-- Filter Value -->
		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">

			<!-- STRING -> text box -->
			<input *ngIf="selected.type === FilterType.STRING"
				class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
				[(ngModel)]="selected.value"
				(ngModelChange)="onValueChanged()">

			<!-- BOOLEAN -> checkbox (generic replacement for the per-page special-case) -->
			<input *ngIf="selected.type === FilterType.BOOLEAN"
				type="checkbox"
				[(ngModel)]="selected.value"
				(ngModelChange)="onValueChanged()">

		</div>
	</ng-container>
</ng-container>

<!-- =========================== MULTIPLE MODE =========================== -->
<ng-container *ngIf="multiple">

	<!-- "Filter" button - each pick ADDS a filter to the active list -->
	<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
		<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
			<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
		</button>
		<ul class="dropdown-menu">
			<li *ngFor="let option of options" (click)="onOptionAdded(option)">
				<a>{{ option.label }}</a>
			</li>
		</ul>
	</div>

	<!-- One label + value input + remove button per active filter -->
	<ng-container *ngFor="let filter of active">
		<!-- Keep label + input + remove button together on one line -->
		<div class="dropdown btn-group edgefinityHeader"
			style="display:inline-flex; align-items:center; gap:6px; margin-left:10px; vertical-align:middle;">

			<span>{{ filter.label }}</span>

			<!-- STRING -> text box -->
			<input *ngIf="filter.type === FilterType.STRING"
				class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
				style="display:inline-block; width:auto; vertical-align:middle;"
				[(ngModel)]="filter.value"
				(ngModelChange)="onValueChanged()">

			<!-- BOOLEAN -> checkbox -->
			<input *ngIf="filter.type === FilterType.BOOLEAN"
				type="checkbox"
				style="vertical-align:middle; margin:0;"
				[(ngModel)]="filter.value"
				(ngModelChange)="onValueChanged()">

			<!-- Remove this filter -->
			<button type="button" class="btn btn-ef btn-sm" (click)="removeFilter(filter)" title="Remove filter">
				<em class="fa fa-times"></em>
			</button>
		</div>
	</ng-container>
</ng-container>
